import { getVehicleEquipment } from '../../server/api/mappers/vehicles.helpers';

/**
 * Mazda
 *
 * ```
 *     State:   For sale - Sale active
 *    Images:   3
 *      Bids:   1
 * User bids:   1
 *    Mapper:   No
 * ```
 */
export default () => {
	const vehicle = {
		additionalDetails: null,
		additionalSpec: null,
		availableFrom: null,
		availableUntil: '2016-03-01T00:00:00.000Z',
		bids: {
			activeBidCount: 1,
			usersBids: [
				{
					dealerContact: {
						id: 100,
					},
					id: 8058,
					value: 12,
				},
			],
		},
		dentsDesc: null,
		displayPrice: null,
		equipment: '',
		exteriorGrade: 'silver',
		hasBeenSmokedIn: null,
		hasDents: null,
		hasLockingWheelNut: null,
		hasMissingParts: null,
		hasOtherContactActiveBid: false,
		hasPaintProblems: null,
		hasPrivatePlate: null,
		hasScratches: null,
		hasScuffedAlloy: null,
		hasServiceRecords: null,
		hasToolsInBoot: null,
		hasWarningLights: null,
		hasWindscreenProblems: false,
		id: 50795,
		independentServiceStampsCount: null,
		interiorType: null,
		isTrade: false,
		isVatQualifying: null,
		isVehicleOnFinance: null,
		keeperStartDate: '2019-12-27T00:00:00.000Z',
		keysCount: null,
		lastMOTDate: null,
		mileage: 50000,
		minimumBid: {
			type: 'bid',
			value: 1000,
		},
		missingPartsDesc: null,
		officialServiceStampsCount: null,
		paintProblemsDesc: null,
		prettyVrm: 'F14 DMA',
		previousKeepersCount: null,
		scratchesDesc: null,
		scuffedAlloyDesc: null,
		seller: {
			distance: 117,
			town: 'Bristol',
		},
		sellerWillAcceptPrice: null,
		serviceHistory: null,
		soldDate: null,
		spec: {
			body: 'Convertible',
			bodyCategory: 'Convertible',
			colour: 'Blue',
			engineSize: 1998,
			firstRegistered: '2019-12-27T00:00:00.000Z',
			fuel: 'Petrol',
			make: 'Mazda',
			model: 'MX-5 Sport NAV +',
			transmission: 'Manual',
			vin: 'JMZND6E7600413657',
		},
		state: {
			category: 'for_sale',
			id: 87,
			name: 'For sale - Sale active',
			slug: 'sale_active',
		},
		tyreProblemsDesc: null,
		vehicleImages: [
			{
				createdAt: '2020-06-09T14:42:19.014Z',
				enquiryId: 50795,
				id: 169834,
				kind: 'exterior_front_driver',
				meta: {
					height: 720,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 960,
					x: 0,
					y: 0,
				},
				source: 'motorway-photos-webapp--pr-262:7cef6a43c79dfcdc613e7ef482c601773c81dd8d',
				url: 'https://motorway-stage.imgix.net/0795/50795/50795-exterior_front_driver-1591713738675.jpeg',
			},
			{
				createdAt: '2020-06-09T14:42:54.647Z',
				enquiryId: 50795,
				id: 169835,
				kind: 'exterior_rear_driver',
				meta: {
					height: 720,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 960,
					x: 0,
					y: 0,
				},
				source: 'motorway-photos-webapp--pr-262:7cef6a43c79dfcdc613e7ef482c601773c81dd8d',
				url: 'https://motorway-stage.imgix.net/0795/50795/50795-exterior_rear_driver-1591713774321.jpeg',
			},
			{
				createdAt: '2020-06-09T14:42:03.410Z',
				enquiryId: 50795,
				id: 169833,
				kind: 'exterior_front_passenger',
				meta: {
					height: 720,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 960,
					x: 0,
					y: 0,
				},
				source: 'motorway-photos-webapp-stage:79838d5b817ed423b212db603d5bafa303ad2817',
				url: 'https://motorway-stage.imgix.net/0795/50795/50795-exterior_front_passenger-1591713723101.jpeg',
			},
		],
		vrm: 'F14DMA',
		warningLightsDesc: null,
		windscreenProblemsDesc: '',
		year: 2019,
	};

	return {
		...vehicle,
		equipmentV2: getVehicleEquipment(vehicle),
	};
};
